import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.grayContrast};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 20px;
`

const Title = styled.span`
  color: ${({ theme }) => theme.colors.text.gray};
  font-size: 1.3rem;
  font-weight: bold;
  text-transform: uppercase;
`

export default class Card extends React.PureComponent {
  renderTitle() {
    if (this.props.title) {
      return (
        <Title> { this.props.title } </Title>
      )
    }

    return null
  }

  render() {
    return (
      <Container className={ this.props.className }>
        { this.renderTitle() }
        { this.props.children }
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/Card/Card.js